var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Breadcrumbs"},[_c('ProgressBar',{class:_vm.stepWidth,attrs:{"steps":_vm.breadcrumbs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }